export default __webpack_public_path__ + "static/media/9.94bc7f95.mp3";